import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberInvalid = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25Z",
			stroke: "currentColor",
			strokeWidth: 1.28333
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 4.375V7.29167",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 10.3245C7.4832 10.3245 7.875 9.9328 7.875 9.4495C7.875 8.9663 7.4832 8.5745 7 8.5745C6.5167 8.5745 6.125 8.9663 6.125 9.4495C6.125 9.9328 6.5167 10.3245 7 10.3245Z",
			fill: "currentColor"
		})
	]
});
export default SvgNumberInvalid;
